(function () {

    var formSkipValidator = function (scope, className) {
        var self = this;
        var _protected = BaseForm.call(self, className, scope);
    };

    /**
     * This modal contain three components:
     * - Archive form for users already hired
     * - Skip reasons to skip candidates not hired yet on not have docs.
     * - Rejection templates.
     */
    angular.module('harriApp')
        .controller('SkipModalController', [
        '$scope', 'modalData', 'onSendToSkip', 'onHide', 'onError',
        function ($scope, modalData, onSendToSkip, onHide, onError) {

            // private entity
            var progressTrackerItems = [];

            var errorAlert = function (error, callback) {
                callback = callback || function () {};

                var errorBody = '<p>Something went wrong please try again later</p>';

                if (error && error.error) {
                    if (error.error.code === 'NO_SKIP_REASON') {
                        errorBody = '<p>The selected reason is no longer available</p>';
                    } else if (error.error.code === 'SERVICE_DISABLED') {
                        errorBody = '<p>Reasons for skipping service has been deactivated</p>';
                    }
                } else {
                    errorBody += '<p>For questions you can reach us at 844.HARRI.HELP (844.427.7443).</p>';
                }

                hAlert(
                    'Something went wrong!',
                    errorBody,
                    function () {
                        callback();
                    },
                    'skip-modal-error-alert'
                );
            };

            var addRejectionTemplatesSection = function () {

                var rejectionTemplatesSection = {
                    id: 'rejection_templates_section',
                    title: $filter("translate")("REJECTION MESSAGE")
                };

                if (progressTrackerItems.length) {
                    rejectionTemplatesSection.disabled = true;
                }

                progressTrackerItems.push(rejectionTemplatesSection);
            };

            // public entity
            $scope.modal = {};
            $scope.modal.brandId = modalData.brandId;
            $scope.modal.candidates = modalData.candidates;
            $scope.modal.data = {};
            $scope.modal.events = {};
            $scope.modal.jobId = modalData.jobId;
            $scope.modal.showRejectionTemplateOnly = modalData.showRejectionTemplateOnly;
            $scope.modal.skipBucketCandidates = modalData.skipBucketCandidates || [];
            $scope.modal.candidatesBucket = modalData.bucket;
            $scope.modal.PASS_BUCKET = AMSAPI.PASSED;
            $scope.modal.archiveSection = modalData.archiveSection;
            $scope.modal.appId = modalData.appId;
            if(modalData.rejectionTemplates) {
                $scope.modal.rejectionTemplates = modalData.rejectionTemplates.message_templates;
                $scope.modal.canSkipRejectionTemplates = modalData.rejectionTemplates.can_skip;
            }
            $scope.modal.source = modalData.source;
            $scope.modal.additionalActionTitle = $filter("translate")('Skip without message');

            $scope.modal.events['templateItemManaged'] = function (item) {
                $scope.modal.close();
                onSendToSkip($scope.modal.brandId, $scope.modal.jobId, $scope.modal.candidates);
            };

            $scope.modal.events['hideModal'] = function (isError) {

                if (isError) {
                    onError();
                }

                $scope.modal.close(true);
            };

            if (modalData.skipReasons) {
                $scope.modal.is_usage_required = modalData.skipReasons.is_usage_required;
                $scope.modal.reasons = modalData.skipReasons.reasons;
            }

            if ($scope.modal.archiveSection) {

                $scope.modal.candidateName = modalData.candidates[0].name || '';
                $scope.modal.archiveReasons = modalData.archiveReasons || {};

                var archiveSection = {
                    id: 'archive_section',
                    title: "Archive Reason"
                };
                progressTrackerItems.push(archiveSection);

                if ($scope.modal.rejectionTemplates && $scope.modal.candidates[0].application_id) {
                    addRejectionTemplatesSection();
                }

            } else {

                if ($scope.modal.reasons) {

                    var skipReasonSection = {
                        id: 'skip_reason_section',
                        title: $filter("translate")("SKIP REASON")
                    };

                    progressTrackerItems.push(skipReasonSection);
                }

                if ($scope.modal.rejectionTemplates) {
                    addRejectionTemplatesSection();
                }
            }

            $scope.modal.hideProgressTrackerHeader = progressTrackerItems.length === 1;

            $scope.modal.progressTracker = new ProgressTracker($scope, {
                autoScroll: false,
                items: progressTrackerItems,
                onInitialized: function (element) {
                    $scope.modal.progressTracker.goTo(progressTrackerItems[0].id);
                },
                onStateChanged: function (item, newState, oldState) {},
                onActiveChanged: function (activeItem, lastActiveItem) {
                    $scope.modal.activeState = activeItem.id;
                },
                onItemClick: function (event, item) {
                    if (ProgressTracker.States.DONE !== item.state) {
                        $scope.modal.progressTracker.goTo(item.id);
                    }
                }
            });

            $scope.modal.formValidator = new formSkipValidator($scope, 'validate-modal-form');

            $scope.modal.close = function (fireOnHide) {
                $scope.$hide();

                if (fireOnHide) {
                    onHide();
                }
            };

            $scope.modal.isSendDisabled = function () {
                return !$scope.modal.data.reasonId;
            };

            $scope.modal.goNextStep = function () {

                if ($scope.modal.formValidator.validator.validate()) {
                    if (progressTrackerItems.length === 2) {
                        $scope.modal.progressTracker.changeState(
                            progressTrackerItems[0].id,
                            ProgressTracker.States.DONE
                        );

                        $scope.modal.progressTracker.changeState(
                            progressTrackerItems[1].id,
                            ProgressTracker.States.NEW
                        );

                        $scope.modal.progressTracker.goTo(progressTrackerItems[1].id);
                    } else {
                        $scope.modal.sending = true;
                        $scope.modal.sendReasons(true);
                    }
                }
            };

            $scope.modal.sendReasons = function (fireSkipItEvent, preventHideModal) {

                var deferred = $q.defer();

                if ($scope.modal.archiveSection) {

                    OnBoardingAPI
                        .archiveCandidate(
                            modalData.prospect_id,
                            $scope.modal.appId,
                            $scope.modal.data.archiveReason
                        ).then(function (response) {
                            $scope.modal.sending = false;
                            deferred.resolve(response);

                            if (fireSkipItEvent) {
                                onSendToSkip($scope.modal.brandId, $scope.modal.jobId, $scope.modal.candidates, $scope.modal.archiveReasons[$scope.modal.data.archiveReason]);
                            }

                            if (!preventHideModal) {
                                $scope.modal.close();
                            }

                            $scope.$digest();
                        }, function (err) {
                            hAlert({
                                title: $filter("translate")('Something went wrong!'),
                                text: JSON.stringify(err),
                                custom_class: 'rejection-templates-error-alert'
                            });
                            $scope.modal.sending = false;
                            deferred.reject(err);
                            $scope.$digest();
                        })
                } else {
                    if (!$scope.modal.showRejectionTemplateOnly && $scope.modal.data.reasonId) {
                        var reasonId = parseInt($scope.modal.data.reasonId);
                        var applicationIds = [];
                        var i;
                        var candidate;

                        $scope.modal.sending = true;

                        for (i in $scope.modal.candidates) {
                            candidate = $scope.modal.candidates[i];
                            applicationIds.push(parseInt(candidate.application_id));
                        }

                        BrandAPI.addSkipReasonToApplicants(
                            $scope.modal.brandId,
                            $scope.modal.jobId,
                            applicationIds,
                            reasonId
                        ).then(function () {
                            if (!preventHideModal) {
                                $scope.modal.close();
                            }

                            $scope.modal.sending = false;
                            deferred.resolve();

                            if (fireSkipItEvent) {
                                onSendToSkip($scope.modal.brandId, $scope.modal.jobId, $scope.modal.candidates);
                            }

                            $scope.$digest();
                        }, function (err) {
                            if (progressTrackerItems.length === 1) {
                                errorAlert(err);
                            }

                            onError();

                            deferred.reject(err);
                            $scope.modal.sending = false;
                            $scope.$digest();
                        });
                    } else {
                        if (fireSkipItEvent) {
                            onSendToSkip($scope.modal.brandId, $scope.modal.jobId, $scope.modal.candidates);
                        }

                        if (!preventHideModal) {
                            $scope.modal.close();
                        }

                        deferred.resolve();
                    }
                }
                return deferred.promise;
            };

        }]);

})();
